import {
  UK_RECESSION_ID,
  UK_RECESSIONS,
  US_RECESSION_ID,
  US_RECESSIONS,
} from '../../components/chartview/panels/plot-bands/PlotBandPresets/plotBandPresets.constants';
import {
  getIsLinear,
  getLinearPlotBandPresetsWithinRange,
  getPlotBandPresetsWithinRange,
} from '../../components/chartview/panels/plot-bands/PlotBandPresets/plotBandPresets.utils';
import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';

function updateChart(stateTree, state, payload, intervalType) {
  const { active } = stateTree.documents;

  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));

  localStorage.setItem('saved', 'false');

  if (intervalType) {
    return {
      ...state,
      [intervalType]: payload,
      mustRender: activeDoc.mustRender,
    };
  }

  return state;
}

function convertPlotBands(chart) {
  const { data, product, sizes } = chart;

  const showUkRecessions =
    data.showUkRecessions || Object.keys(sizes).some((key) => sizes[key].axes.showUkRecessions);
  const showUsRecessions =
    data.showUsRecessions || Object.keys(sizes).some((key) => sizes[key].axes.showRecessions);

  const isLinear = getIsLinear(data.quarterlyResults, data.series);

  // formatted values to be passed to `getLinearPlotBandPresetsWithinRange` or
  // `getPlotBandPresetsWithinRange`
  const state = {
    categories: data.categories,
    chartFont: data.chartFont,
    currentProperty: product,
    reverseDateMonth: data.reverseDateMonth,
  };
  const recessionUs = { id: US_RECESSION_ID, recessionData: US_RECESSIONS };
  const recessionUk = { id: UK_RECESSION_ID, recessionData: UK_RECESSIONS };

  let legacyUsPlotBandPresets = [];

  if (showUsRecessions) {
    legacyUsPlotBandPresets = isLinear
      ? getLinearPlotBandPresetsWithinRange(state, recessionUs)
      : getPlotBandPresetsWithinRange(state, recessionUs);
  }

  let legacyUkPlotBandPresets = [];
  if (showUkRecessions) {
    legacyUkPlotBandPresets = isLinear
      ? getLinearPlotBandPresetsWithinRange(state, recessionUk)
      : getPlotBandPresetsWithinRange(state, recessionUk);
  }

  return {
    mustRender: false,
    plotBands: data.plotBands.length ? data.plotBands : [],
    plotBandPresets: data.plotBandPresets?.length
      ? data.plotBandPresets
      : [...legacyUsPlotBandPresets, ...legacyUkPlotBandPresets],
    showUkRecessions,
    showUsRecessions,
  };
}

function fetchPlotBandsInfo(state, action) {
  if (!action.data) return state;
  if (action.data.status === 'success') return convertPlotBands(action.data.body.chart);
  return state;
}

export { fetchPlotBandsInfo, updateChart };
